<template>
  <scout-form
    :is-modified="!!value.length"
    label="スカウト特典"
  >
    <label
      v-for="(option ,i) in specialFavorsMaster"
      :key="i"
      v-tooltip="{ content: option.description}"
      class="boss-scout-bonus pega-mr-5 pega-input"
    >
      <input
        :checked="value.includes(option.id.toString())"
        :value="option.id"
        :data-test="'option-' + option.id"
        type="checkbox"
        @change="onChange"
      >
      <span
        :data-test="'option-name-' + option.id"
        class="boss-bonus-check-text boss-bonus-check-mark"
      >{{ option.name }}</span>
    </label>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import { mapGetters } from 'vuex'

export default {
  components: {
    ScoutForm
  },
  props: {
    value: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      values: []
    }
  },
  computed: {
    ...mapGetters([
      'specialFavorsMaster'
    ])
  },
  methods: {
    onChange (e) {
      if (e.target.checked) {
        this.values.push(e.target.value)
      } else {
        this.values = this.values.filter(v => v !== e.target.value)
      }
      this.$emit('input', this.values)
    }
  }
}
</script>
